var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        ref: "priceBox",
        class: [
            _vm.$style.agreementContainer
        ],
        domProps: {
            "innerHTML": _vm._s(_setup.agreementContent)
        }
    });
};
var staticRenderFns = [];
export { render, staticRenderFns };
